import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-40dcba6c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sizing" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 賞品の引き換え手続きは一度行うと元に戻せません。係員の指示に従って操作してください。 ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 戻る ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PrizeWonImage = _resolveComponent("PrizeWonImage")!
  const _component_StepANoticeInstructionsBeforeUse = _resolveComponent("StepANoticeInstructionsBeforeUse")!
  const _component_StepBNoticeWithConfirmUse = _resolveComponent("StepBNoticeWithConfirmUse")!
  const _component_AppButtonPrimary = _resolveComponent("AppButtonPrimary")!
  const _component_AppButtonSecondary = _resolveComponent("AppButtonSecondary")!
  const _component_NotesOnUse = _resolveComponent("NotesOnUse")!

  return (_openBlock(), _createElementBlock("main", null, [
    _createVNode(_component_PrizeWonImage, {
      "prize-won-image-url": _ctx.prizeWonImageUrl,
      "has-used-prize-coupon": _ctx.hasUsedPrizeCoupon,
      "prize-coupon-used-at-string": _ctx.prizeCouponUsedAtString
    }, null, 8, ["prize-won-image-url", "has-used-prize-coupon", "prize-coupon-used-at-string"]),
    _createElementVNode("div", _hoisted_1, [
      (_ctx.isCouponStepAWaitingOnCouponUse)
        ? (_openBlock(), _createBlock(_component_StepANoticeInstructionsBeforeUse, {
            key: 0,
            class: "step-notice"
          }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.isCouponStepBWaitingOnPressUseButton)
        ? (_openBlock(), _createBlock(_component_StepBNoticeWithConfirmUse, {
            key: 1,
            class: "step-notice",
            "is-checked": _ctx.isConfirmCheckboxChecked,
            onCheck: _ctx.toggleConfirmCheckbox
          }, null, 8, ["is-checked", "onCheck"]))
        : _createCommentVNode("", true),
      (_ctx.showButton)
        ? (_openBlock(), _createBlock(_component_AppButtonPrimary, {
            key: 2,
            "is-loading": _ctx.isLoading,
            "is-disabled": _ctx.isDisabledButton,
            onButton: _ctx.clickUseButton
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.buttonText), 1)
            ]),
            _: 1
          }, 8, ["is-loading", "is-disabled", "onButton"]))
        : _createCommentVNode("", true),
      (_ctx.showButton)
        ? (_openBlock(), _createBlock(_component_AppButtonSecondary, {
            key: 3,
            onButton: _ctx.goBack
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }, 8, ["onButton"]))
        : _createCommentVNode("", true),
      _createVNode(_component_NotesOnUse)
    ])
  ]))
}